module.exports = __webpack_public_path__ + "img/131.7.b625bbed.png";